<template>
  <body>
    <div style="width: 100%; background-color: rgba(0, 0, 0, 0)">
      <img style=" height: 100vh; width: 100vw; overflow: hidden; position: absolute;" :src="require(`@/assets/RegisterNew/bgp0${randomPic}.jpg`)"/>
      <span id="actionFrameId">
        <!--注册操作框，流程1,手机注册-->
        <div v-if="registerStep == 1" class="actionFrame">
          <div class="logo">
            <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
          </div>
          <div class="titleCtn">
            <div class="title-1">用户注册&实名认证</div>
          </div>
          <div @click="whyIdentifyTip = true" class="text3-ctn">
            为什么要实名认证
            <img src="../assets/RegisterNew/为什么-默认.png" style="margin-bottom: -1px" height="12" width="12"/>
            <div v-if="whyIdentifyTip" style="position: absolute; left: 105px; top: -65px">
              <img @click.stop="whyIdentifyTip = false" src="../assets/RegisterNew/实名提示.png" width="321"/>
              <img @click.stop="whyIdentifyTip = false" style="position: absolute; top: 5px; right: 5px" src="../assets/RegisterNew/关闭提示内容.png" height="16" width="16"/>
            </div>
          </div>
          <!-- 手机号 -->
          <div class="input-ctn" style="margin-top: 20px">
            <v-text-field v-model="telephone" label="手机号" placeholder="请输入手机号" outlined>
              <template v-slot:prepend-inner>
                <div style=" width: 35px; padding-top: 3px; padding-bottom: 2px; border-right: solid 1px rgba(0, 0, 0, 0.25); color: rgba(0, 0, 0, 0.35);">+86</div>
              </template>
            </v-text-field>
          </div>
          <!--图片验证码-->
          <div class="input-ctn" style="margin-top: 15px">
            <div class="verifyInputCtn" style="margin-right: 5px">
                <v-text-field v-model="verifyCode" label="图片验证码" placeholder=" " outlined></v-text-field>
            </div>
            <div class="verifyInputCtn" style="width: 190px;cursor:pointer;position: relative;" @click="captchaImage">
                <img :src="imgBase64" alt="" style="position: absolute;width: 190px;height: 60px;">
            </div>
          </div>
          <!-- 短信验证码 -->
          <div class="input-ctn" style="margin-top: 15px">
            <v-text-field v-model="accessCode" label="短信验证码" placeholder="请输入短信验证码" outlined @blur="ifCanRegister">
              <template v-slot:append>
                <v-fade-transition leave-absolute>
                  <div @click="clickSendCode" :class="canSendAgain ? 'getAccessCode' : 'getAccessCode-disabled'">{{ countDown }}</div>
                </v-fade-transition>
              </template>
            </v-text-field>
          </div>
          <!-- 真实姓名 -->
          <div class="input-ctn" style="margin-top: 15px">
            <v-text-field v-model="realName" label="真实姓名" placeholder="请输入真实姓名" outlined key="123"></v-text-field>
          </div>
          <!--身份证号-->
          <div class="input-ctn" style="margin-top: 15px">
            <v-text-field v-model="IDCard" label="身份证号码" placeholder="请输入身份证号码" outlined @blur="ifCanIdentify"></v-text-field>
          </div>
          <!--身份证，认证解释-->
          <div class="input-ctn" style="height: 16px;line-height: 16px;font-size: 12px;color:#979797;margin-top: 7px;padding-left: 3px;">
            <v-icon size="14" color="rgba(0,0,0,0.3)">info</v-icon> 我们仅通过支付宝认证您的真实信息，但不会记录您的身份证信息
          </div>
          <!--服务条款和隐私政策-->
          <div class="input-ctn" style="height: 20px; margin-top: 20px">
            <v-checkbox v-model="read_checkbox" @change="ifCanRegister">
              <template v-slot:label>
                <div style="font-size: 14px">我已阅读并同意
                  <a target="_blank" href="/ServiceAgreement" @click.stop style="text-decoration: none; color: #006699">《服务协议》</a>和
                  <a target="_blank" href="/PrivacyPolicy" @click.stop style="text-decoration: none; color: #006699">《隐私政策》</a>和
                  <a target="_blank" href="/MapServiceAgreement" @click.stop style="text-decoration: none; color: #006699">《在线访问产品使用协议》</a>
                </div>
              </template>
            </v-checkbox>
          </div>
          <!--点击注册-->
          <div  @click="clickRegister" :class="registerAllow ? 'operateButton' : 'operateButton_disabled'" style="margin-top: 45px">下一步</div>
          <!--底部文字-->
          <div class="text-ctn" style="margin-top: 40px">
            已有吉林一号账号？现在就去<span @click="$router.push('/Login')" style="color: #006699;cursor:pointer;">登录</span>
          </div>
          <div class="text2-ctn">
            Copyright © 2023-2025 长光卫星技术股份有限公司
            <a target="_blank" href="/PrivacyPolicy" @click.stop style="text-decoration: none; color: #979797">· 隐私政策</a>
            <a target="_blank" href="/ServiceAgreement" @click.stop style="text-decoration: none; color: #979797">· 服务协议</a>
            <a target="_blank" href="/MapServiceAgreement" @click.stop style="text-decoration: none; color: #979797">· 在线访问产品使用协议</a>
          </div>
          <!--错误提示-->
          <div v-if="showAlert" class="alertCtn">{{ alertTip }}
            <img class="closeAlert" @click="showAlert = false" src="../assets/RegisterNew/关闭提示内容.png" height="22" width="22"/>
          </div>
        </div>
        <!--注册操作框，流程2,支付宝人脸识别-->
        <div v-if="registerStep == 2" class="actionFrame" style="height: 680px;">
          <div class="logo">
            <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
          </div>
          <div class="titleCtn" style="margin-top: 110px">
            <div class="title-2">请打开支付宝扫一扫</div>
          </div>
          <div class="contImgCtn">
            <img :src="certificationImg" height="300" width="300" style="margin-top: -32px;margin-left: -32px"/>
            <!--二维码已过期蒙层-->
            <div v-if="timeOutMantle" class="contImgCtnMantle">
              <div class="text5-ctn">已过期</div>
              <div @click="clickRefresh" class="contImgCtnMantle-button">刷新</div>
            </div>
          </div>
          <div @click="backToChangeInput" class="text4-ctn">&lt; 返回重新输入</div>
          <!--底部文字-->
          <div class="text2-ctn">
            Copyright © 2023-2025 长光卫星技术股份有限公司
            <a target="_blank" href="/PrivacyPolicy" @click.stop style="text-decoration: none; color: #979797">· 隐私政策</a>
            <a target="_blank" href="/ServiceAgreement" @click.stop style="text-decoration: none; color: #979797">· 服务协议</a>
            <a target="_blank" href="/MapServiceAgreement" @click.stop style="text-decoration: none; color: #979797">· 在线访问产品使用协议</a>
          </div>
          <!--错误提示-->
          <div v-if="showAlert" class="alertCtn">{{ alertTip }}
            <img class="closeAlert" @click="showAlert = false" src="../assets/RegisterNew/关闭提示内容.png" height="22" width="22"/>
          </div>
        </div>
        <!-- 注册操作框，流程3,设置密码 -->
        <div v-if="registerStep == 3" class="actionFrame" style="height: 680px;">
          <div class="logo">
            <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
          </div>
          <div class="titleCtn">
            <div class="title-1">配置密码</div>
          </div>
          <!--手机号-->
          <div class="input-ctn" style="margin-top: 50px">
            <v-text-field v-model="telephone" label="手机号" placeholder="请输入手机号" outlined readonly disabled>
              <template v-slot:prepend-inner>
                <div style=" width: 35px; padding-top: 3px; padding-bottom: 2px; border-right: solid 1px rgba(0, 0, 0, 0.25); color: rgba(0, 0, 0, 0.35);">+86</div>
              </template>
            </v-text-field>
          </div>
          <!--设置密码-->
          <div class="input-ctn" style="margin-top: 20px">
            <v-text-field v-model="password1" label="设置密码*" placeholder="限8-20位且包含大小写字母和数字" outlined
                :rules="[rules.passwordPattern]" :type="ifShowPassword ? 'text' : 'password'" @change="checkIfCanRegister2">
              <template v-slot:append>
                <v-fade-transition leave-absolute>
                  <div v-if="ifShowPassword==false" @click="showPassword" style="width: 30px;height: 20px;margin-top: 5px;margin-left: 10px;cursor:pointer">
                    <img src="../assets/Login/显示密码.png" height="13" width="19"/>
                  </div>
                  <div v-if="ifShowPassword==true" @click="hidePassword" style="width: 30px;height: 20px;margin-top: 5px;margin-left: 10px;cursor:pointer">
                    <img src="../assets/Login/隐藏密码.png" height="16" width="19"/>
                  </div>
                </v-fade-transition>
              </template>
            </v-text-field>
          </div>
          <!--再次输入密码-->
          <div class="input-ctn" style="margin-top: 20px">
            <v-text-field v-model="password2" label="再次输入密码*" placeholder=" " outlined :rules="[rules.password2Pattern]"
            :type="ifShowPassword ? 'text' : 'password'" @change="checkIfCanRegister2">
              <template v-slot:append>
                <v-fade-transition leave-absolute>
                  <div v-if="ifShowPassword==false" @click="showPassword" style="width: 30px;height: 20px;margin-top: 5px;margin-left: 10px;cursor:pointer">
                    <img src="../assets/Login/显示密码.png" height="13" width="19"/>
                  </div>
                  <div v-if="ifShowPassword==true" @click="hidePassword" style="width: 30px;height: 20px;margin-top: 5px;margin-left: 10px;cursor:pointer">
                    <img src="../assets/Login/隐藏密码.png" height="16" width="19"/>
                  </div>
                </v-fade-transition>
              </template>
            </v-text-field>
          </div>
          <!--点击注册-->
          <div @click="clickRegister2" :class="IfCanRegister2 ? 'operateButton' : 'operateButton_disabled'" style="margin-top: 40px">注册</div>
          <!--底部文字-->
          <div class="text2-ctn">
            Copyright © 2023-2025 长光卫星技术股份有限公司
            <a target="_blank" href="/PrivacyPolicy" @click.stop style="text-decoration: none; color: #979797">· 隐私政策</a>
            <a target="_blank" href="/ServiceAgreement" @click.stop style="text-decoration: none; color: #979797">· 服务协议</a>
            <a target="_blank" href="/MapServiceAgreement" @click.stop style="text-decoration: none; color: #979797">· 在线访问产品使用协议</a>
          </div>
          <!--错误提示-->
          <div v-if="showAlert" class="alertCtn">
            {{ alertTip }}
            <img
                class="closeAlert"
                @click="showAlert = false"
                src="../assets/RegisterNew/关闭提示内容.png"
                height="22"
                width="22"
            />
          </div>
        </div>
        <!--注册操作框，流程4,完成全部流程-->
        <div v-if="registerStep==4" class="actionFrame"  style="height: 680px;">
          <div class="logo">
            <img src="~@/assets/newHome/logo.png" height="40" width="175"/>
          </div>
          <!--如果认证成功-->
          <div class="detailInformationCtn2">
            <div class="text6-ctn" style="margin-top: 60px">
              <img src="../assets/RegisterNew/认证成功.png" height="44" width="44"/>
            </div>
            <div class="text6-ctn" style="margin-top: 30px;padding-left: 0px">
              您已完成全流程注册
            </div>
            <!--立即返回首页-->
            <div @click="$router.push('/')" class="operateButton" style="margin-top: 92px;">
              立即返回首页
            </div>
            <!--继续了解吉林一号生态会员-->
            <div @click="jumpWithPermission('可游客', '/store', '/')" class="operateButton2" style="margin-top: 15px;">
              前往遥感商城
            </div>
          </div>
          <!--底部文字-->
          <div class="text2-ctn">Copyright © 2023-2025 长光卫星技术股份有限公司
            <a target="_blank" href="/PrivacyPolicy" @click.stop style="text-decoration:none;color: #979797;">· 隐私政策</a>
            <a target="_blank" href="/ServiceAgreement" @click.stop style="text-decoration:none;color: #979797;">· 服务协议</a>
            <a target="_blank" href="/MapServiceAgreement" @click.stop style="text-decoration:none;color: #979797;">· 在线访问产品使用协议</a>
          </div>
          <!--错误提示-->
          <div v-if="showAlert" class="alertCtn">{{alertTip}}
            <img class="closeAlert" @click="showAlert=false;" src="../assets/RegisterNew/关闭提示内容.png" height="22" width="22"/>
          </div>
        </div>
      </span>
    </div>
  </body>
</template>

<script>
  import JSEncrypt from 'jsencrypt'
  import {rootUrl} from '@/globalConfig'
  export default {
  name: "Register",
  data() {
    return {
      lastTime_success_show:'立即完善注册',
      timer:'',//循环定时器
      timer1:'',//循环定时器
      certificationId:'',
      certificationImg:'',
      ifShowPassword:false,
      liaojiequdao: "",
      shiyongchengdu: "",
      mainPurpose: "", //主要用途
      focusIndustry: "", //关注行业
      companyName: "", //公司或组织
      countryList: [],
      areaList: [],
      areaListTemp: [],
      purposeArea2: "", //关注子区域
      purposeArea1: "中国", //关注区域
      password2: "",
      password1: "",
      shiyongchengduItems: [
        "从未用过",
        "入门级使用",
        "中等程度使用",
        "专家级/重度使用",
      ],
      liaojiequdaoItems: [
        "自媒体(微信公众号/微博/抖音/B站/企鹅号等)",
        "长光卫星官网",
        "曾是“遥感易购”用户",
        "行业论坛或展会",
        "合作伙伴",
        "口口相传"
      ],
      purposeItems: [
        "遥感影像解译与分析",
        "数据采集",
        "软件或服务开发",
        "评估商业机会",
        "科学研究",
        "单纯探索",
      ],
      industryItems: [
            "大气环境保护",
            "水环境保护",
            "土壤环境保护",
            "绿色低碳",
            "生态环境保护",
            "环境灾害应急",
            "农业资源监测",
            "耕地保护",
            "农情监测",
            "农业保险",
            "农村人居环境整治",
            "农业气象",
            "乡村振兴",
            "森林资源监测与管理",
            "湿地资源监测与管理",
            "国家公园、森林公园和自然保护区监测",
            "林业生态工程监测",
            "森林病虫害防治",
            "森林火灾",
            "自然资源",
            "其他",
        ],
      certifySuccess: false, //是否验证成功
      timeOutMantle: false, //二维码过期
      certificationAllow: false, //是否可以实名认证
      checkIdentifyResult: false, //身份证格式是否正确
      registerAllow: false,
      checkPhoneResult: "", //手机号码验证是否通过，通过为true，否则为字符串
      realName: "",
      IDCard: "",
      whyIdentifyTip: false, //实名认证原因提示框
      registerStep: 1, //注册流程进行到的步骤，预计流程分为5步
      randomPic: 7, //1-7随机数，用于选择背景图片
      telephone: "", //手机号
      countDown: "获取验证码", //发送验证码，与再次发送倒计时
      canSendAgain: true, //可以发送验证码
      accessCode: "", //短信验证码
      read_checkbox: false, //已阅读并同意选择框
      alertTip: "请输入正确的手机号码",
      showAlert: false,
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        phone: (value) => {
          const pattern = /^[0-9]{11}$/;
          if (value) {
            return pattern.test(value) || "请填写正确的手机号码";
          } else {
            return true;
          }
        },
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (value) {
            return pattern.test(value) || "请填写正确的邮箱格式";
          } else {
            return true;
          }
        },
        passwordPattern: (value) => {
          const pattern =/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/;
          if (value) {
            return (
              pattern.test(value) ||
              "请填写正确的密码格式，要求为8-20位大小写字母和数字的组合"
            );
          } else {
            return true;
          }
        },
        password2Pattern: (value) => {
          if (value != this.password1) {
            return "请保持前后密码一致";
          } else {
            return true;
          }
        },
        notNull: (value) => {
          if (value == "" || value == null) {
            return "此项不能为空";
          } else {
            return true;
          }
        },
      },
      //第二版新添加
      IfCanRegister2:false,//检测可否继续注册
      verifyCode:'',
      imgBase64:'',
      uuid:'',
      encrypted:''
    };
  },
  methods: {
    //带权限判断的跳转
    jumpWithPermission(type, path, fromUrl,event) {
      //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
      //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
      let loginUserId = localStorage.getItem("userId"); //是否已登录
      let authentication = localStorage.getItem("authentication"); //0:已实名；1：未实名
      if (type == "可游客") {
          if (fromUrl) {
              window.open(
                  rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                  "_self"
              );
          } else {
              window.open(rootUrl + path, "_self");
          }
      } else if (type == "仅登录") {
          //已登录
          if (loginUserId) {
              if (fromUrl) {
                  window.open(
                      rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                      "_self"
                  );
              } else {
                  window.open(rootUrl + path, "_self");
              }
          }
          //未登录
          else {
              if (fromUrl) {
                  window.open(
                      rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
                      "_self"
                  );
              } else {
                  window.open(rootUrl + "/Login", "_self");
              }
          }
      } else if (type == "仅实名") {
          //已登录
          if (loginUserId) {
              //已实名
              if (authentication == "0") {
                  if (fromUrl) {
                  window.open(
                      rootUrl + path + "?fromUrl=" + rootUrl + fromUrl,
                      "_self"
                  );
                  } else {
                      window.open(rootUrl + path, "_self");
                  }
              }
              //未实名
              else {
                  window.open(rootUrl + "/Authentication", "_self");
              }
          }
          //未登录
          else {
              if (fromUrl) {
                  window.open(
                      rootUrl + "/Login" + "?fromUrl=" + rootUrl + fromUrl,
                      "_self"
                  );
              } else {
                  window.open(rootUrl + "/Login", "_self");
              }
          }
      }
    },
    //识别屏幕缩放比例
    detectZoom(){
      var ratio = 0,
              screen = window.screen,
              ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      }
      else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      }
      else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio){
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },
    //获取图片验证码
    captchaImage(){
        this.axios.get("/loginapi/captchaImage?type=register").then((res) => {
          if(res.data.code==200){
            this.imgBase64=res.data.data.img
            this.uuid=res.data.data.uuid
          }else{
            this.alertTip='获取图片验证码失败'
            this.showAlert=true
          }
      })
    },
    //点击支付宝扫一扫下的返回重新输入
    backToChangeInput(){
      clearInterval(this.timer);
      this.registerStep = 1;
    },
    //刷新二维码
    clickRefresh(){
      this.timeOutMantle=false;
      clearInterval(this.timer);
      this.clickCertification();

    },
    //查询实名认证是否通过
    inquiryCertificationResult(){
      let param = new FormData();
      param.append("orderId", this.certificationId);
      param.append("name", this.realName);
      param.append("phone", this.telephone);
      this.axios.post("/loginapi/AlipayIdentity/queryAlipayRegisterCertifyStatus", param).then((res) => {
        console.log(res);
        let resData = res.data;
        if(resData.success==true){
          clearInterval(this.timer);
          this.registerStep=3;
        } else {
          //账号信息不完善
          if (resData.code == 50001) {
            if (this.timer != null) {
              clearInterval(this.timer);
            }
          }
          if (resData.code == 50002) {
            if (this.timer != null) {
              clearInterval(this.timer);
            }
          }
          //超时
          if (resData.code == 50003) {
            this.timeOutMantle = true;
            if (this.timer != null) {
              clearInterval(this.timer);
            }
          }
        }
      });
    },
    //点击实名认证
    clickCertification(){
      let param = new FormData();
      param.append("userName", this.realName);
      param.append("userIdCard", this.IDCard);
      this.axios.post("/loginapi/AlipayIdentity/getAlipayCertifyQRCode", param).then((res) => {
        console.log(res);
        let resData = res.data;
        if(resData.success==true){
          this.registerStep=2;
          this.certificationImg=resData.data.QRCode;
          this.certificationId=resData.data.orderId;
          this.timer = setInterval(this.inquiryCertificationResult,2000);
        }
        else {
          this.alertTip = '身份信息有误，请重新填写'
          this.registerStep=2;
        }
      });
    },
    //设置显示密码
    showPassword(){
      this.ifShowPassword=true;
    },
    //设置隐藏密码
    hidePassword(){
      this.ifShowPassword=false;
    },
    //完善信息，点击完成
    completeAndSubmit() {
      const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/;
      if (this.password1 == this.password2) {
        if (!pattern.test(this.password1)) {
          this.alertTip = "请填写正确的密码格式";
          this.showAlert = true;
          return;
        }
      } else {
        this.alertTip = "密码前后不一致";
        this.showAlert = true;
        return;
      }
      if (this.companyName.trim() == "" || this.companyName.trim() == null) {
        this.alertTip = "企业/组织名不能为空";
        this.showAlert = true;
        return;
      }
      if (this.mainPurpose == "" || this.mainPurpose == null) {
        this.alertTip = "主要用途不能为空";
        this.showAlert = true;
        return;
      }
      if (this.focusIndustry == "" || this.focusIndustry == null) {
        this.alertTip = "关注行业不能为空";
        this.showAlert = true;
        return;
      }
      if (this.purposeArea2 == "" || this.purposeArea2 == null) {
        this.alertTip = "关注子区域不能为空";
        this.showAlert = true;
        return;
      }
      let submitData={
        "name": this.realName,//名字，与account相同
        "password": this.password1,//密码
        "phone":this.telephone,//手机号
        "company": this.companyName,//公司
        "industry": this.focusIndustry,//关注行业
        "focusArea": this.purposeArea1,//关注地区
        "focusField": this.purposeArea2,//关注子地区
        "mainPuprose": this.mainPurpose,//主要用途
        "useDegree": this.shiyongchengdu,//对卫星遥感使用程度
        "learnChannel": this.liaojiequdao//从渠道了解
      }

      this.axios.post("/loginapi/completeUserInfoForRegister", submitData).then((res) => {
        console.log(res)
        if(res.data.success){
          this.registerStep=6;
          this.alertTip = "";
          this.showAlert = false;
        }
      else {
          this.alertTip = "信息添加出错,请重新输入";
          this.showAlert = true;
        }

      });
    },
    //判断是否可以实名认证
    ifCanIdentify: function () {
      this.checkIdentifyResult = this.checkIDCode(this.IDCard);
      if (this.checkIdentifyResult == true && this.realName.length > 1) {
        this.certificationAllow = true;
        //取消错误提示
        this.alertTip = "";
        this.showAlert = false;
      }
      //未输入真实姓名
      else if (this.realName.length <= 1) {
        this.certificationAllow = false;
        this.alertTip = "请输入真实姓名";
        this.showAlert = true;
        return;
      }
      //身份证号码格式不正确
      else if (this.checkIdentifyResult != true) {
        this.certificationAllow = false;
        this.alertTip = this.checkIdentifyResult;
        this.showAlert = true;
        return;
      }
    },
    //判断身份证格式是否正确
    checkIDCode: function (IDCode) {
      let GAT=IDCode.slice(0,6)
      if(GAT=='810000'||GAT=='820000'||GAT=='830000'){
        return "身份证号码格式错误";
      }
      let IdentifyPattern = /(^[1-9][0-9]{14}$)|(^[1-9][0-9]{16}[0-9xX]$)/;
      if (IDCode) {
        return IdentifyPattern.test(IDCode) || "身份证号码格式错误";
      } else {
        return "身份证号码格式错误";
      }
    },
    //点击下一步（先验证手机号，通过之后进入下一步人脸识别）
    clickRegister: function () {
      if (this.registerAllow) {
        let param = new FormData();
        param.append("phone", this.telephone);
        param.append("prefix", "");
        param.append("verifyCode", this.accessCode);
        this.axios.post("/loginapi/checkCodeForRegister", param).then((res) => {
          console.log(res);
          let resData = res.data;
          if (resData.success == false) {
            this.alertTip = resData.message;
            this.showAlert = true;
          } else if (resData.success == true) {
            this.clickCertification()
          }
        });
      }
    },
    //注册用户
    clickRegister2:function () {
      const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/;
      if (this.password1 == this.password2) {
        if (!pattern.test(this.password1)) {
          this.alertTip = "请填写正确的密码格式";
          this.showAlert = true;
          return;
        }
      } else {
        this.alertTip = "密码前后不一致";
        this.showAlert = true;
        return;
      }
      //根据参数判断是否是开放平台来的
      const urlParams = new URLSearchParams(window.location.search);
      const returnSys = urlParams.get('returnSys');

      let param = new FormData();
      // param.append("verifyCode", this.accessCode);
      param.append("phone", this.telephone);
      param.append("password", this.password1);
      if(returnSys=='open'||returnSys=='kaifang'){
        param.append("origin", 'open');
      }
      // —— 来源归因:非空且有效期内则带上 sourceFrom 与 bdVid ——
      const sourceFrom = this.getSourceFrom();
      if (sourceFrom !== '') {
        param.append("sourceFrom", sourceFrom);
        param.append("bdVid", this.getSourceId());
      }
      this.axios.post("/loginapi/addRegisterInfo", param).then((res) => {
        let resData = res.data;
        if (resData.success == false) {
          this.alertTip = resData.message;
          this.showAlert = true;
        } else if (resData.success == true) {
          this.registerStep = 4;
        }
      });

    },
    //检测密码与确认密码，是否可注册
    checkIfCanRegister2:function () {
      const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,20}$/;
      if (this.password1 == this.password2) {
        if (!pattern.test(this.password1)) {
          this.IfCanRegister2 = false;
          return;
        }
        else{
          this.IfCanRegister2 = true;
          this.showAlert = false;
        }
      } else {
        this.IfCanRegister2 = false;
        return;
      }
    },
    //判断是否可以注册
    ifCanRegister: function () {
      if (
        this.checkPhoneResult == true &&
        this.read_checkbox == true &&
        this.accessCode.length > 1 &&
        this.verifyCode!='' &&
        this.realName.length>1 &&
        this.checkIDCode(this.IDCard) == true
      ) {
        this.registerAllow = true;
      } else {
        this.registerAllow = false;
      }
    },
    //验证手机格式
    phonePattern: function (phone) {
      const pattern = /^[0-9]{11}$/;
      if (phone) {
        return pattern.test(phone) || "请填写正确的手机号码";
      } else {
        return "请填写正确的手机号码";
      }
    },
    //点击获取验证码
    clickSendCode: function () {
      let checkResult = this.phonePattern(this.telephone);
      this.checkPhoneResult = checkResult;
      //如果手机号通过正则检验
      if (checkResult == true) {
        //取消电话号码格式错误提示
        this.alertTip = "";
        this.showAlert = false;
        //如果可以发送验证码
        if (this.canSendAgain) {
          //立即禁用按钮，防止重复点击
          this.canSendAgain=false;
          //调用发送验证码的函数
          this.sendCode();
        }
      } else {
        this.alertTip = checkResult;
        this.showAlert = true;
      }
    },
    //json加密
    RSA_encryption(jsonData){
        var PUBLIC_KEY='MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA2i8ZSgjf9ARRHRC/fFlGlWV6j6z78//8YlxGlAOq4a4tNS/Da35mfwkPM1qa7lr9dwjmT5CwTJVuHoUfsA5CmMHi+x+9vF5eyy62m1/yv8zgIwdQEaD0SLjDrnzqhM9k/vxpWR/d64rz6zUEwbYJM7NgNohlg3vqBYZlTJL7t5/145+CnSzmhIaeBl4sbAulFydGTqDWvzvfR6Y9eBQUQjyEyLom1vS4piq2OYAKVkX1ozo05xt49mD9eUYdDfHlxOsbPl8DwXpxl2XiJR3+vXkNIFKTdPTSYKR3Gh17sQelX+GwF0nixCAaqplUnw+/FVBmtBkih/eplGTQ8f5mDwIDAQAB'
        var encrypt = new JSEncrypt()
        encrypt.setPublicKey('-----BEGIN PUBLIC KEY-----' + PUBLIC_KEY + '-----END PUBLIC KEY-----')
        var encrypted = encrypt.encrypt(JSON.stringify(jsonData))
        this.encrypted=encrypted
    },
    //发送验证码函数
    sendCode: function () {
      var json={
        "phone": this.telephone,
        "uuid": this.uuid,
        "code": this.verifyCode
      }
      this.RSA_encryption(json)
      this.axios.post("/loginapi/sendRegisterCode",this.encrypted,{
          headers: {
            'Content-Type': "application/json;charset=utf-8",
        },
      }).then((res)=>{
              let resData=res.data
              if(resData.success==false){
                  //失败时恢复按钮状态，允许用户重试
                  this.canSendAgain=true;
                  this.alertTip=resData.message;
                  this.showAlert=true;
                  if(resData.code==50008){
                    this.captchaImage()
                  }
              }else{
                this.sendAgainCountDown();
              }
          })
    },
    //发送倒计时
    sendAgainCountDown: function () {
      let t = 60;
      this.canSendAgain = false;
      let timer1 = setInterval(() => {
        this.countDown = "重新发送 (" + t + "s)";
        t--;
        if (t < 0) {
          this.canSendAgain = true;
          this.countDown = "获取验证码";
          clearInterval(timer1);
        }
      }, 1000);
    },
  },
  mounted() {
    //获取验证码
    this.captchaImage()
    // this.axios.get("/accessapi/searchService/Area/id=-1").then((res) => {
    //   let areaItems = res.data.data;
    //   this.print(areaItems);
    //   for (let i = 0; i < areaItems.length; i++) {
    //     this.areaListTemp.push(areaItems[i].areaName);
    //   }
    //   this.areaList = this.areaListTemp;
    // });
    // this.axios.get("/accessapi/searchService/countryList").then((res) => {
    //   let countryItems = res.data.data;
    //   let countryList = [];
    //   countryList.push("中国");
    //   for (let i = 0; i < countryItems.length; i++) {
    //     countryList.push(countryItems[i].countryName);
    //   }
    //   this.countryList = countryList;
    // });
    //屏幕适应问题
    let screenZoom=this.detectZoom() //屏幕放大倍数
    let screenWidth=window.screen.width
    let divFrame = document.getElementById("actionFrameId");
    if(screenWidth<2500){
      divFrame.setAttribute("style","zoom:"+(100-(screenZoom-100)/1.8).toFixed(2).toString()+"%");
    }
  },
  created() {
    this.randomPic = Math.floor(Math.random() * 7 + 1);
  },
  watch: {
    accessCode:{
      handler:function () {
        if(this.accessCode.length>5){
          this.ifCanRegister()
        }
      }
    },
    IDCard:{
      handler:function () {
        this.ifCanRegister()
      }
    },
    realName:{
      handler:function () {
        this.ifCanRegister()
      }
    }
  },
};
</script>

<style scoped>
.contImgCtnMantle-button {
  margin-top: 39px;
  margin-left: 73px;
  width: 96px;
  height: 44px;
  background: #006699;
  border-radius: 8px;
  line-height: 44px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.text6-ctn {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  text-align: center;
}
.text5-ctn {
  margin-top: 99px;
  width: 100%;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 22px;
  text-align: center;
}
.contImgCtnMantle {
  position: absolute;
  top: 0px;
  width: 242px;
  height: 242px;
  background: rgba(255, 255, 255, 0.75);
}
.contImgCtn {
  position: relative;
  margin-top: 36px;
  width: 242px;
  height: 242px;
  margin-left: 219px;
}
/* 定义滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  margin-top: 38px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
  border-radius: 10px;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(255, 255, 255, 0.65);
  background-color: rgba(143, 143, 143, 0.48);
}
.detailInformationCtn2 {
  position: absolute;
  top: 130px;
  left: 0px;
  width: 680px;
  height: 479px;
}
.detailInformationCtn {
  position: absolute;
  top: 230px;
  left: 0px;
  width: 680px;
  height: 419px;
  overflow-y: scroll;
}
.text4-ctn {
  margin-top: 79px;
  margin-left: 60px;
  width: 200px;
  height: 17px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3a3a3a;
  line-height: 17px;
  cursor: pointer;
}
.text3-ctn {
  position: relative;
  margin-left: 261px;
  margin-top: 15px;
  width: 158px;
  height: 24px;
  background: #f5f5f6;
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
}
.text7-ctn {
  margin-left: 64px;
  margin-top: 30px;
  margin-bottom: 50px;
  width: 499px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #979797;
  line-height: 17px;
}
.text2-ctn {
  position: absolute;
  bottom: 33px;
  left: 60px;
  width: 560px;
  min-height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #979797;
  line-height: 17px;
}
.text-ctn {
  margin-left: 62px;
  width: 560px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  line-height: 20px;
}
.operateButton2 {
  margin-left: 60px;
  width: 560px;
  height: 54px;
  line-height: 54px;
  border: 1px solid #006699;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #006699;
  cursor: pointer;
}
.operateButton {
  margin-left: 60px;
  width: 560px;
  height: 54px;
  line-height: 54px;
  background: #006699;
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.operateButton_disabled {
  margin-left: 60px;
  width: 560px;
  height: 54px;
  line-height: 54px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  text-align: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.getAccessCode {
  width: 150px;
  margin-top: 5px;
  /*height: 40px;*/
  /*line-height: 40px;*/
  text-align: right;
  padding-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #006699;
  cursor: pointer;
}
.getAccessCode-disabled {
  width: 150px;
  margin-top: 5px;
  /*height: 40px;*/
  /*line-height: 40px;*/
  text-align: right;
  padding-right: 10px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  cursor: pointer;
}
.purposeArea {
  float: left;
  width: 240px;
  height: 60px;
}
.input-ctn {
  width: 560px;
  height: 60px;
  margin-left: 60px;
}
.title-1 {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  border-bottom: 3px solid #006699;
}
.title-2 {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
}
.titleCtn {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 35px;
  margin-top: 85px;
}
.logo {
  position: relative;
  top: 58px;
  left: 204px;
  width: 272px;
  height: 44px;
  text-align: center;
  padding-right: 15px;
  font-size: 30px;
}
.closeAlert {
  position: absolute;
  top: 16px;
  right: 16px;
  cursor: pointer;
}
.alertCtn {
  position: absolute;
  top: -94px;
  left: 0px;
  width: 680px;
  height: 54px;
  line-height: 54px;
  background: #ff4040;
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
}
.actionFrame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 680px;
  height: 880px;
  background: #ffffff;
  border-radius: 16px;
}
.verifyInputCtn{
        width:360px;
        height:60px;
        float:left;
    }
</style>
